module.exports = __webpack_public_path__ + "static/media/ROADH.64be40ea.svg";